import { Component, OnInit, Input, Output, HostBinding } from '@angular/core';
import { Artikel } from '../models/artikel.model';

@Component({
  selector: 'sws-artikelzeile',
  templateUrl: './artikelzeile.component.html',
  styleUrls: ['./artikelzeile.component.css']
})
export class ArtikelzeileComponent implements OnInit {
 @Input() product: Artikel;
 @HostBinding('attr.class') cssClass = 'item';
  
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// D:/Crossplatform/swsLagerinfo/src/app/artikelzeile/artikelzeile.component.ts